<div class="container-fluid p-0">
  <!-- Título -->

  @if (!carregando) {
    <div class="borda_inferior bg-light pt-3 pr-4 pb-3 pl-4" [@esvanecerDesvanecer]="'in'">
      @if (produto == null) {
        <div class="titulo_texto">Novo Produto</div>
      }
      @if (produto != null) {
        <div class="titulo_texto">Alterar Produto</div>
      }
    </div>
  }

  @if (!carregando) {
    <div [@esvanecerDesvanecer]="'in'">
      <!-- Itens (Menu) -->
      <div class="pt-3 pr-4 pb-0 pl-4">
        <div class="d-flex flex-wrap justify-content-center itens_menu">
          <div class="item_menu pt-2 pb-2 pl-3" [ngClass]="(itemSelecionado == 0) ? 'item_menu_selecionado' : ''" (click)="alterarItemSelecionado(0)">
            1. Informações
          </div>
          <div class="item_menu pt-2 pb-2 pl-3" [ngClass]="(itemSelecionado == 1) ? 'item_menu_selecionado' : ''" (click)="alterarItemSelecionado(1)">
            2. Ficha Técnica (Links)
          </div>
          <div class="item_menu pt-2 pb-2 pl-3" [ngClass]="(itemSelecionado == 2) ? 'item_menu_selecionado' : ''" (click)="alterarItemSelecionado(2)">
            3. Fotos
          </div>
          @if (configuracao != null && configuracao.b2b_segmentado) {
            <div class="item_menu pt-2 pb-2 pl-3" [ngClass]="(itemSelecionado == 3) ? 'item_menu_selecionado' : ''" (click)="alterarItemSelecionado(3)">
              4. Segmento
            </div>
          }
        </div>
        <hr class="mt-2 mb-2" />
      </div>
      <!-- Informações -->
      @if (itemSelecionado == 0) {
        <div class="pr-4 pb-4 pl-4" [@desvanecer]="'in'">
          <form [formGroup]="formProdutoInformacoes" (ngSubmit)="salvarInformacoes()">
            <div class="form-row">
              <div class="form-group col-sm-2">
                <label><b>Código:</b></label>
                <input class="form-control form-control-sm" type="text" name="codigo" [ngClass]="{ 'is-invalid': enviadoProdutoInformacoes && fin.codigo.errors?.required }" formControlName="codigo" />
                @if (enviadoProdutoInformacoes && fin.codigo.errors?.required) {
                  <div class="erro pt-1">Código em branco!</div>
                }
              </div>
              <div class="form-group col-sm-10">
                <label><b>Descrição:</b></label>
                <input class="form-control form-control-sm" type="text" name="descricao" [ngClass]="{ 'is-invalid': enviadoProdutoInformacoes && fin.descricao.errors?.required }" formControlName="descricao" />
                @if (enviadoProdutoInformacoes && fin.descricao.errors?.required) {
                  <div class="erro pt-1">Descrição em branco!</div>
                }
              </div>
            </div>
            <div class="form-row">
              <div class="form-group col-sm-3">
                <label><b>Qtde (Estoque):</b></label>
                <input class="form-control form-control-sm" type="number" name="qtde_estoque" [ngClass]="{ 'is-invalid': enviadoProdutoInformacoes && fin.qtde_estoque.errors?.required }" formControlName="qtde_estoque" />
                @if (enviadoProdutoInformacoes && fin.qtde_estoque.errors?.required) {
                  <div class="erro pt-1">Qtde (Estoque) em branco!</div>
                }
              </div>
            </div>
            <div class="form-row">
              <div class="form-group col-sm-3">
                <label><b>Preço: R$</b></label>
                <input class="form-control form-control-sm" type="number" name="preco" [ngClass]="{ 'is-invalid': enviadoProdutoInformacoes && fin.preco.errors?.required }" formControlName="preco" />
                @if (enviadoProdutoInformacoes && fin.preco.errors?.required) {
                  <div class="erro pt-1">Preço em branco!</div>
                }
              </div>
              <div class="form-group col-sm-3">
                <label><b>Custo: R$</b></label>
                <input class="form-control form-control-sm" type="number" name="custo" [ngClass]="{ 'is-invalid': enviadoProdutoInformacoes && fin.custo.errors?.required }" formControlName="custo" />
                @if (enviadoProdutoInformacoes && fin.custo.errors?.required) {
                  <div class="erro pt-1">Custo em branco!</div>
                }
              </div>
            </div>
            <div class="form-row">
              <div class="form-group col-sm-3">
                <label><b>Ativo:</b></label>
                <select class="form-control form-control-sm" name="ativo" #ativo (change)="selecionarAtivo(ativo.value)" disabled>
                  <option value="0" [selected]="!produtoAtivo">Não</option>
                  <option value="1" [selected]="produtoAtivo">Sim</option>
                </select>
              </div>
            </div>
            <div class="form-row">
              <div class="form-group col-sm-12">
                <label><b>Ficha Técnica:</b></label>
                <textarea class="form-control form-control-sm" rows="2" name="ficha_tecnica" formControlName="ficha_tecnica"></textarea>
              </div>
            </div>
            <hr class="mt-2 mb-2" />
            <div class="d-flex justify-content-end">
              <button class="btn btn-success btn_formulario" type="submit">Salvar</button>
            </div>
          </form>
        </div>
      }
      <!-- Ficha Técnica (Links) -->
      @if (itemSelecionado == 1) {
        <div class="pr-4 pb-4 pl-4" [@desvanecer]="'in'">
          <form [formGroup]="formProdutoFichaTecnica" (ngSubmit)="salvarFichaTecnica()">
            <div class="form-row">
              <div class="form-group col-sm-6">
                <label><b>Título:</b></label>
                <input class="form-control form-control-sm" type="text" name="titulo" [ngClass]="{ 'is-invalid': enviadoProdutoFichaTecnica && ffi.titulo.errors?.required }" formControlName="titulo" />
                @if (enviadoProdutoFichaTecnica && ffi.titulo.errors?.required) {
                  <div class="erro pt-1">Título em branco!</div>
                }
              </div>
              <div class="form-group col-sm-6">
                <label><b>Link:</b></label>
                <input class="form-control form-control-sm" type="text" name="link" [ngClass]="{ 'is-invalid': enviadoProdutoFichaTecnica && ffi.link.errors?.required }" formControlName="link" />
                @if (enviadoProdutoFichaTecnica && ffi.link.errors?.required) {
                  <div class="erro pt-1">Link em branco!</div>
                }
              </div>
            </div>
            <hr class="mt-2 mb-2" />
            <div class="d-flex justify-content-end">
              <button class="btn btn-success btn_formulario" type="submit">Salvar</button>
            </div>
          </form>
          <hr class="mt-2 mb-2" />
          <div class="table-responsive">
            <table class="table table-sm">
              <thead>
                <tr>
                  <th></th>
                  <th class="tabela_borda">Título</th>
                  <th class="tabela_borda">Link</th>
                </tr>
              </thead>
              <tbody>
                @for (produtoFichaTecnica of produtosFichaTecnica; track produtoFichaTecnica) {
                  <tr>
                    <td class="text-center tabela_acao">
                      <i class="fa fa-remove btn_tabela_acao" placement="right" ngbTooltip="Excluir" (click)="excluirFichaTecnica(produtoFichaTecnica.id)"></i>
                    </td>
                    <td class="tabela_borda">{{ produtoFichaTecnica.titulo }}</td>
                    <td class="tabela_borda">{{ produtoFichaTecnica.link }}</td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        </div>
      }
      <!-- Fotos -->
      @if (itemSelecionado == 2) {
        <div class="pr-4 pb-4 pl-4" [@desvanecer]="'in'">
          <div class="form-row">
            <div class="form-group col-sm-12">
              <label><b>Selecionar Arquivo:</b></label>
              <input class="form-control form-control-sm" type="file" accept="image/png" (change)="uploadProdutoFoto($event)" #arquivoFoto />
              <div class="mensagem pt-1">* Extensão PNG / * Fundo transparente / * Resolução ideal 210x210 / * Tamanho Máximo (160KB)</div>
              @if (fotoErro) {
                <div class="erro pt-1">Arquivo selecionado acima de 60KB!</div>
              }
              @if (fotoInvalida) {
                <div class="erro pt-1">Arquivo inválido!</div>
              }
            </div>
          </div>
          <div class="pt-2 pb-2">
            @if (foto != '') {
              <div class="col-sm-12 text-center">
                <div class="d-flex flex-column justify-content-center">
                  <div class="p-2">
                    <img class="produto_foto" [src]="foto" alt="Foto" />
                  </div>
                  <div class="p-2">
                    <button class="btn btn-success btn_formulario" type="button" (click)="salvarProdutoFoto()">Salvar</button>
                    <button class="btn btn-danger btn_formulario" type="button" (click)="removerProdutoFoto()">Remover</button>
                  </div>
                </div>
              </div>
            }
          </div>
          <hr class="mt-2 mb-2" />
          <div class="table-responsive">
            <table class="table table-sm">
              <thead>
                <tr>
                  <th></th>
                  <th class="tabela_borda"></th>
                  <th class="text-center tabela_borda">Dt. Atualização</th>
                  <th class="text-center tabela_borda">Imagem</th>
                  <th class="text-center tabela_borda">Padrão</th>
                </tr>
              </thead>
              <tbody>
                @for (produtoFotos of produtosFotos; track produtoFotos) {
                  <tr>
                    <td class="text-center tabela_acao">
                      @if (!produtoFotos.padrao) {
                        <div>
                          <i class="fa fa-check btn_tabela_acao" placement="right" ngbTooltip="Definir como Padrão" (click)="definirProdutoFotoPadrao(produtoFotos.id)"></i>
                        </div>
                      }
                    </td>
                    <td class="text-center tabela_acao tabela_borda">
                      <i class="fa fa-remove btn_tabela_acao" placement="right" ngbTooltip="Excluir" (click)="excluirProdutoFoto(produtoFotos.id)"></i>
                    </td>
                    <td class="text-center tabela_borda">{{ produtoFotos.dt_ultima_atualizacao | date: 'dd/MM/yyyy HH:mm:ss' }}</td>
                    <td class="text-center tabela_borda">
                      <img class="produto_imagem" [src]="produtoFotos.imagem" alt="Produto" />
                    </td>
                    <td class="text-center tabela_borda">{{ produtoFotos.padrao ? 'Sim' : 'Não' }}</td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        </div>
      }
      <!-- Segmento -->
      @if (itemSelecionado == 3 && (configuracao != null && configuracao.b2b_segmentado)) {
        <div class="pr-4 pb-4 pl-4" [@desvanecer]="'in'">
          <div class="form-row">
            <div class="form-group col-sm-12">
              <label><b>Segmento:</b></label>
              <select class="form-control form-control-sm" name="segmento" #segmento (change)="selecionarSegmento(segmento.value)">
                @for (opcao of segmentos; track opcao) {
                  <option [value]="opcao.segment" [selected]="segmentoSelecionado != null ? opcao.segment == segmentoSelecionado.segment : null">{{ opcao.segment }}</option>
                }
              </select>
            </div>
          </div>
          <hr class="mt-2 mb-2" />
          <div class="d-flex justify-content-end">
            <button class="btn btn-success btn_formulario" type="button" (click)="salvarSegmento()">Salvar</button>
          </div>
          <hr class="mt-2 mb-2" />
          <div class="table-responsive">
            <table class="table table-sm">
              <thead>
                <tr>
                  <th></th>
                  <th class="tabela_borda">Segmento</th>
                </tr>
              </thead>
              <tbody>
                @for (produtoSegmento of produtosSegmento; track produtoSegmento) {
                  <tr>
                    <td class="text-center tabela_acao">
                      <i class="fa fa-remove btn_tabela_acao" placement="right" ngbTooltip="Excluir" (click)="excluirSegmento(produtoSegmento.id)"></i>
                    </td>
                    <td class="tabela_borda">{{ produtoSegmento.segment }}</td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        </div>
      }
    </div>
  }
</div>
